import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import IndexRepository from "../Repositories/IndexRepository";

class IndexBloc {
  workUnitChannel = new Subject();
  workUnitEchelonTwoChannel = new Subject();
  EmployeeStatusChannel = new Subject();
  downloadDRHChannel = new Subject();
  echelonChannel = new Subject();
  indexChannel = new Subject();
  employeeCategoriesChannel = new Subject();
  exportExcelChannel = new Subject();
  repository = new IndexRepository();

  constructor() {
    this.indexChannel.next({ status: apiResponse.INITIAL });
    this.workUnitChannel.next({ status: apiResponse.INITIAL });
    this.workUnitEchelonTwoChannel.next({ status: apiResponse.INITIAL });
    this.EmployeeStatusChannel.next({ status: apiResponse.INITIAL });
    this.downloadDRHChannel.next({ status: apiResponse.INITIAL });
    this.echelonChannel.next({ status: apiResponse.INITIAL });
    this.employeeCategoriesChannel.next({ status: apiResponse.INITIAL });
    this.exportExcelChannel.next({ status: apiResponse.INITIAL });
  }

  fetchWorkUnit = async (query) => {
    try {
      this.workUnitChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchWorkUnit(query)
        .then((result) => {
          this.workUnitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };

  fetchWorkUnitEchelonTwo = async (query) => {
    try {
      this.workUnitEchelonTwoChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchWorkUnitEchelonTwo(query)
        .then((result) => {
          this.workUnitEchelonTwoChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitEchelonTwoChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchEmployeeStatus = async (query) => {
    try {
      this.EmployeeStatusChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEmployeeStatus(query)
        .then((result) => {
          this.EmployeeStatusChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.EmployeeStatusChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchEchelon = async (query) => {
    try {
      this.echelonChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEchelon(query)
        .then((result) => {
          this.echelonChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.echelonChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {}
  };

  fetchDownloadDRH = async (query) => {
    try {
      this.downloadDRHChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchDownloadDRH(query)
        .then((result) => {
          this.downloadDRHChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.downloadDRHChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchEmployeeCategories = async (query) => {
    try {
      this.employeeCategoriesChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEmployeeCategories(query)
        .then((result) => {
          this.employeeCategoriesChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeCategoriesChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {}
  };

  fetchExportExcel = async (query) => {
    try {
      this.exportExcelChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchExportExcel(query)
        .then((result) => {
          this.exportExcelChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.exportExcelChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscribed");
    }
  };
}

export default IndexBloc;
